import { useEffect, useState } from 'react'
import apiClient from '../../global/utils/apiClient'
import { useGolferStore } from '../store/GolferStore'
import { useMetaStore } from '../store/MetaStore'
import GolferInfoView from '../views/GolferInfoView'

const GolferInfoController = () => {
  const [golferRounds, setGolferRounds] = useState([])
  const [selectedGolferId, setSelectedGolferId] = useState('')
  const [currentGolfer, setCurrentGolfer] = useState(null)

  const setPageTitle = useMetaStore((state) => state.setPageTitle)
  const golfers = useGolferStore((state) => state.golfers)
  const populateActiveGolfers = useGolferStore((state) => state.populateActiveGolfers)

  useEffect(() => {
    setPageTitle('Golfer Info')
    populateActiveGolfers(true, true)
  }, [])

  const handleGolferSelect = async (golferId) => {
    setSelectedGolferId(golferId)
    if (!golferId) {
      setCurrentGolfer(null)
      setGolferRounds([])
      return
    }

    try {
      // Always fetch fresh golfer data from the API bypassing cache
      const gResp = await apiClient.get(`/gskapi/golfers/find/${golferId}?noCache=true`)
      setCurrentGolfer(gResp.data)

      const rResp = await apiClient.get(`/gskapi/rounds/golfer/${golferId}`)
      const sortedRounds = rResp.data.sort((a, b) => new Date(b.roundDate) - new Date(a.roundDate))
      setGolferRounds(sortedRounds)

    } catch (error) {
      console.error('Error fetching golfer stats:', error)
    }
  }

  return (
    <GolferInfoView
      golfers={golfers}
      selectedGolferId={selectedGolferId}
      onGolferSelect={handleGolferSelect}
      currentGolfer={currentGolfer}
      golferRounds={golferRounds}
    />
  )
}

export default GolferInfoController
